// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HeaderMyRepComponent } from "@conklin/App/Widgets/Header/HeaderMyRep";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

export interface MyRepStyles {
    wrapper?: InjectableCss;
}

export const myRepStyles: MyRepStyles = {};

const styles = myRepStyles;

const MyRep: FC<WidgetProps> = () => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <HeaderMyRepComponent
                showTitle={false}
                fields={{
                    contactUsUrl: "",
                    support: [],
                }}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: MyRep,
    definition: {
        displayName: "My Sale Rep",
        group: "Common",
        allowedContexts: ["MyAccountPage"],
    },
};

export default widgetModule;
